export default {
    "short": {
        "min": 1,
        "max": 1,
        "orthogonal": true,
        "diagonal": false,
        "name": "Short",
    },
    "mid": {
        "min": 2,
        "max": 2,
        "orthogonal": true,
        "diagonal": true,
        // "diagonal": false,
        "type": "arc",
        "name": "Long",
    },
    "long": {
        "min": 2,
        "max": 3,
        "orthogonal": true,
        "diagonal": true,
        "type": "arc",
        "name": "Long"
    },
    "ortho": {
        "min": 1,
        "max": 2,
        "orthogonal": true,
        "diagonal": false,
        "type": "line",
    },
    // "diag-mid-range": {
    //     // "min": 2,
    //     // "max": 2,
    //     // "orthogonal": true,
    //     // "diagonal": true,
    //     "min": 1, "max": 1,
    //     "directions": [
    //         {"x": -2, "order": 0},
    //         {"x": +2, "order": 1},
    //         {"y": -2, "order": 2},
    //         {"y": +2, "order": 3},
    //         {"x": -1, "y": +1, "order": 4},
    //         {"x": +1, "y": +1, "order": 5},
    //         {"x": -1, "y": -1, "order": 6},
    //         {"x": +1, "y": -1, "order": 7},
    //     ],
    //     "type": "arc",
    // },
    // "northsouth-range": {
    //     "min": 1,
    //     "max": 6,
    //     "directions": [
    //         {"y": -1},
    //         {"y": +1},
    //     ],
    //     // "orthogonal": true,
    //     // // "diagonal": true,
    //     // "diagonal": false,
    //     "type": "arc",
    // },
    // "eastwest-range": {
    //     "min": 1,
    //     "max": 1,
    //     "directions": [
    //         {"order": 0},
    //         {"x": -1, "order": 1},
    //         {"x": -2, "order": 2},
    //         {"x": -3, "order": 3},
    //         {"x": -4, "order": 4},
    //         {"x": -5, "order": 5},
    //         {"x": -6, "order": 6},
    //         {"x": +1, "order": 1},
    //         {"x": +2, "order": 2},
    //         {"x": +3, "order": 3},
    //         {"x": +4, "order": 4},
    //         {"x": +5, "order": 5},
    //         {"x": +6, "order": 6},
    //     ],
    //     // "orthogonal": true,
    //     // "diagonal": false,
    //     "type": "arc",
    // },
    // "cross-range": {
    //     // "min": 1,
    //     // "max": 2,
    //     // "orthogonal": true,
    //     "min": 1, "max": 1,
    //     "directions": [
    //         {"order": 0},
    //         {"x": -1, "order": 1},
    //         {"x": -2, "order": 2},
    //         {"y": -1, "order": 1},
    //         {"y": -2, "order": 2},
    //         {"x": +1, "order": 1},
    //         {"x": +2, "order": 2},
    //         {"y": +1, "order": 1},
    //         {"y": +2, "order": 2},
    //     ],
    //     "type": "arc"
    // },
    // "x-range": {
    //     "min": 1,
    //     "max": 2,
    //     "directions": [
    //         {"x": -1, "y": +1},
    //         {"x": +1, "y": -1},
    //         {"x": +1, "y": +1},
    //         {"x": -1, "y": -1},
    //     ],
    //     // "orthogonal": false,
    //     // "diagonal": true,
    //     "type": "arc"
    // },
    // "line": {
    //     "min": 1,
    //     "max": 5,
    //     "orthogonal": true,
    //     "diagonal": false,
    //     "type": "line",
    // }
}
